// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**** Documents Catalog tile page stuff ****/
/* /lms-web/catalog/ & */
.catalog .assignmentsHeader {
  margin-bottom: 30px;
}

.catalog .row.catalogBody {
  margin-left: -20px;
  margin-right: -20px;
}

/**** Subcategory styling. (The list page under each category tile) ****/
/* Ex: lms-web/catalog/view/1025/ */

.catalogList .assignmentsHeader h2,
#documents .assignmentsHeader h2 {
  padding-left: 3rem;
}

.catalog .assignmentsHeader img.icon {
  display: block;
  height: 60px;
  margin-left: 2rem;
  position: relative;
  top: 15px;
  width: 60px;
}

/* body */
#subcategory .row.subcategoryBody,
#documentsSubcategory .row.documentsBody {
  margin-right: -30px;
  margin-left: -30px;
}

/* Make sure the accordion rows are nice and tight */
.col-md-12 .panel-group .panel .panel {
  margin-top: 0.8rem;
}

.catalogList .panel-group .panel + .panel {
  margin-top: 0.8rem;
}

.catalogList .panel-group {
  margin-bottom: 0;
  margin-top: 0.8rem;
}

.catalogList .panel-body {
  padding-left: 7.5rem;
}
/* End accordion row styling */

/* The two header levels in the document/catalog accordion */
.col-md-12 .panel-group .panel .panel-heading .accordion-toggle {
  font-weight: bold;
}

/* the lowest level links in the accordion */
#subcategory .childLink {
  padding-left: 2.5rem;
  margin-top: 0.8rem;
}

#subcategory .childLink a {
  color: black;
  font-weight: bold;
  text-decoration: none;
}

#subcategory .childLink a:hover {
  text-decoration: underline;
}

/* Plus minus icon on document & category list pages */
.col-md-12 .panel-group .panel .panel-heading .accordion-toggle .plusMinus {
  color: #1eabe3;
  width: 15px;
  margin-right: 15px;
  display: inline-block;
}

/**** Category list page 
 * This page is right below the accordion page. You get there by clicking on of the accordion links
 * ****/

/* Turn the description into a preview 
Make the short version of the description have a line wrapping. */
#subcategory p.description.short {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
/* Hide the launch button in the slide down on the list page */
#subcategory .hideOnListPages {
  display: none;
}

/**** UNCATEGORIZED CSS CLASSES ****/
.col-md-12 .panel-group .panel {
  border: none;
  border-radius: 0px;
  box-shadow: none;
}

.col-md-12 .panel-group .panel .panel-heading {
  background: none;
  background-color: #e5e5e5;
}

.col-md-12 .panel-group .panel .panel-heading .accordion-toggle {
  color: #000;
  font-size: 16px;
  text-decoration: none;
}

.col-md-12 .panel-group .panel .panel-collapse .panel-body {
  border: none;
  padding: 0px;
}

.catalogList .col-md-12 .panel-group .panel .panel-collapse .panel-body {
  padding-left: 30px;
}

.col-md-12 .panel-group .panel .panel-collapse .panel-body .children h3 a {
  font-size: 42px;
}

.catalog .col-md-4 {
  padding: 5px;
}

#catalog .col-md-4 .background {
  height: 200px;
  width: 100%;
}

.catalog .col-md-4 .info {
  bottom: 0;
  height: 100%;
  position: absolute;
  width: 100%;
}

.catalog .col-md-4 .info h3 {
  color: #fff;
  margin: 15px auto;
  text-align: center;
  width: 74%;
  font-size: 16px;
  font-weight: bold;
}

.catalogList .panel-group .childLink {
  background-color: #f2f2f2;
  padding: 7px 15px;
}

.catalog .col-md-4 img.icon {
  height: 44%;
  margin: 25px auto 0;
  width: 20%;
}

/* Only catalog header should have
 * a padding-left of 1rem 
 * because it's the only document/category
 * page without an icon to the left of the
 * header */
#catalog .assignmentsHeader h2 {
  padding-left: 1rem;
}

.web .button {
  text-decoration: none;
  background: #fff;
  color: #00a1de;
  outline: 0;
  display: inline-block;
  padding: 0.1em 2em;
  border: 2px solid #00a1de;
  border-radius: 7px;
  font-family: 'Calibre';
  font-size: 12px;
  text-align: center;
  text-decoration: none;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  -webkit-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
}

.web .button:active,
.button:hover {
  outline: 0;
  background-color: #00a1de;
  color: #fff;
}

.web .BAIiconLinks {
  margin: 10px;
  width: 50px;
  height: auto;
  display: block;
  margin-left: 25%;
}

.web hr {
  border: 0;
  clear: both;
  display: block;
  width: 100%;
  background-color: #0076a8;
  height: 1px;
}

.web h2 {
  color: #0076a8;
}

.web .buttonDiv {
  float: right;
  padding: 20px;
}

.web .bluelink {
  color: #00a1de;
  font-size: 14px;
}

.web .productFeatures {
  margin-top: 20px;
}

.web .productAnnouncements {
  padding-bottom: 20px;
}

.web .subHeader {
  color: #00a3de;
  font-weight: bold;
  padding-bottom: 5px;
}

.web ul {
  list-style: none; /* Remove default bullets */
  margin-left: -25px;
}

.web ul li::before {
  content: '\\2022'; /* Add content: \\2022 is the CSS Code/unicode for a bullet */
  color: #0076a8; /* Change the color */
  font-weight: bold; /* If you want it to be bold */
  display: inline-block; /* Needed to add space between the bullet and the text */
  width: 1em; /* Also needed for space (tweak if needed) */
  margin-left: -1em; /* Also needed for space (tweak if needed) */
}

#downloadCatalogLinks .catalogDownload {
  color: #1eabe3;
  text-decoration: none;
  font-size: 1.25em;
  border: none;
  background-color: white;
  float: right;
  margin-top: -10px;
  margin-bottom: -10px;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/catalog/catalog.css"],"names":[],"mappings":"AAAA,4CAA4C;AAC5C,wBAAwB;AACxB;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,wEAAwE;AACxE,mCAAmC;;AAEnC;;EAEE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA,SAAS;AACT;;EAEE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,oDAAoD;AACpD;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;AACA,8BAA8B;;AAE9B,4DAA4D;AAC5D;EACE,iBAAiB;AACnB;;AAEA,4CAA4C;AAC5C;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,sDAAsD;AACtD;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;;OAEO;;AAEP;iEACiE;AACjE;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA,8DAA8D;AAC9D;EACE,aAAa;AACf;;AAEA,oCAAoC;AACpC;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,UAAU;AACZ;;AAEA;;;;WAIW;AACX;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,kCAAkC;EAClC,gCAAgC;EAChC,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA;;EAEE,UAAU;EACV,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB,EAAE,2BAA2B;EAC7C,kBAAkB;AACpB;;AAEA;EACE,gBAAgB,EAAE,4DAA4D;EAC9E,cAAc,EAAE,qBAAqB;EACrC,iBAAiB,EAAE,8BAA8B;EACjD,qBAAqB,EAAE,wDAAwD;EAC/E,UAAU,EAAE,4CAA4C;EACxD,iBAAiB,EAAE,4CAA4C;AACjE;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;AACtB","sourcesContent":["/**** Documents Catalog tile page stuff ****/\n/* /lms-web/catalog/ & */\n.catalog .assignmentsHeader {\n  margin-bottom: 30px;\n}\n\n.catalog .row.catalogBody {\n  margin-left: -20px;\n  margin-right: -20px;\n}\n\n/**** Subcategory styling. (The list page under each category tile) ****/\n/* Ex: lms-web/catalog/view/1025/ */\n\n.catalogList .assignmentsHeader h2,\n#documents .assignmentsHeader h2 {\n  padding-left: 3rem;\n}\n\n.catalog .assignmentsHeader img.icon {\n  display: block;\n  height: 60px;\n  margin-left: 2rem;\n  position: relative;\n  top: 15px;\n  width: 60px;\n}\n\n/* body */\n#subcategory .row.subcategoryBody,\n#documentsSubcategory .row.documentsBody {\n  margin-right: -30px;\n  margin-left: -30px;\n}\n\n/* Make sure the accordion rows are nice and tight */\n.col-md-12 .panel-group .panel .panel {\n  margin-top: 0.8rem;\n}\n\n.catalogList .panel-group .panel + .panel {\n  margin-top: 0.8rem;\n}\n\n.catalogList .panel-group {\n  margin-bottom: 0;\n  margin-top: 0.8rem;\n}\n\n.catalogList .panel-body {\n  padding-left: 7.5rem;\n}\n/* End accordion row styling */\n\n/* The two header levels in the document/catalog accordion */\n.col-md-12 .panel-group .panel .panel-heading .accordion-toggle {\n  font-weight: bold;\n}\n\n/* the lowest level links in the accordion */\n#subcategory .childLink {\n  padding-left: 2.5rem;\n  margin-top: 0.8rem;\n}\n\n#subcategory .childLink a {\n  color: black;\n  font-weight: bold;\n  text-decoration: none;\n}\n\n#subcategory .childLink a:hover {\n  text-decoration: underline;\n}\n\n/* Plus minus icon on document & category list pages */\n.col-md-12 .panel-group .panel .panel-heading .accordion-toggle .plusMinus {\n  color: #1eabe3;\n  width: 15px;\n  margin-right: 15px;\n  display: inline-block;\n}\n\n/**** Category list page \n * This page is right below the accordion page. You get there by clicking on of the accordion links\n * ****/\n\n/* Turn the description into a preview \nMake the short version of the description have a line wrapping. */\n#subcategory p.description.short {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n/* Hide the launch button in the slide down on the list page */\n#subcategory .hideOnListPages {\n  display: none;\n}\n\n/**** UNCATEGORIZED CSS CLASSES ****/\n.col-md-12 .panel-group .panel {\n  border: none;\n  border-radius: 0px;\n  box-shadow: none;\n}\n\n.col-md-12 .panel-group .panel .panel-heading {\n  background: none;\n  background-color: #e5e5e5;\n}\n\n.col-md-12 .panel-group .panel .panel-heading .accordion-toggle {\n  color: #000;\n  font-size: 16px;\n  text-decoration: none;\n}\n\n.col-md-12 .panel-group .panel .panel-collapse .panel-body {\n  border: none;\n  padding: 0px;\n}\n\n.catalogList .col-md-12 .panel-group .panel .panel-collapse .panel-body {\n  padding-left: 30px;\n}\n\n.col-md-12 .panel-group .panel .panel-collapse .panel-body .children h3 a {\n  font-size: 42px;\n}\n\n.catalog .col-md-4 {\n  padding: 5px;\n}\n\n#catalog .col-md-4 .background {\n  height: 200px;\n  width: 100%;\n}\n\n.catalog .col-md-4 .info {\n  bottom: 0;\n  height: 100%;\n  position: absolute;\n  width: 100%;\n}\n\n.catalog .col-md-4 .info h3 {\n  color: #fff;\n  margin: 15px auto;\n  text-align: center;\n  width: 74%;\n  font-size: 16px;\n  font-weight: bold;\n}\n\n.catalogList .panel-group .childLink {\n  background-color: #f2f2f2;\n  padding: 7px 15px;\n}\n\n.catalog .col-md-4 img.icon {\n  height: 44%;\n  margin: 25px auto 0;\n  width: 20%;\n}\n\n/* Only catalog header should have\n * a padding-left of 1rem \n * because it's the only document/category\n * page without an icon to the left of the\n * header */\n#catalog .assignmentsHeader h2 {\n  padding-left: 1rem;\n}\n\n.web .button {\n  text-decoration: none;\n  background: #fff;\n  color: #00a1de;\n  outline: 0;\n  display: inline-block;\n  padding: 0.1em 2em;\n  border: 2px solid #00a1de;\n  border-radius: 7px;\n  font-family: 'Calibre';\n  font-size: 12px;\n  text-align: center;\n  text-decoration: none;\n  -moz-transition: all 0.2s ease-out;\n  -o-transition: all 0.2s ease-out;\n  -webkit-transition: all 0.2s ease-out;\n  transition: all 0.2s ease-out;\n}\n\n.web .button:active,\n.button:hover {\n  outline: 0;\n  background-color: #00a1de;\n  color: #fff;\n}\n\n.web .BAIiconLinks {\n  margin: 10px;\n  width: 50px;\n  height: auto;\n  display: block;\n  margin-left: 25%;\n}\n\n.web hr {\n  border: 0;\n  clear: both;\n  display: block;\n  width: 100%;\n  background-color: #0076a8;\n  height: 1px;\n}\n\n.web h2 {\n  color: #0076a8;\n}\n\n.web .buttonDiv {\n  float: right;\n  padding: 20px;\n}\n\n.web .bluelink {\n  color: #00a1de;\n  font-size: 14px;\n}\n\n.web .productFeatures {\n  margin-top: 20px;\n}\n\n.web .productAnnouncements {\n  padding-bottom: 20px;\n}\n\n.web .subHeader {\n  color: #00a3de;\n  font-weight: bold;\n  padding-bottom: 5px;\n}\n\n.web ul {\n  list-style: none; /* Remove default bullets */\n  margin-left: -25px;\n}\n\n.web ul li::before {\n  content: '\\2022'; /* Add content: \\2022 is the CSS Code/unicode for a bullet */\n  color: #0076a8; /* Change the color */\n  font-weight: bold; /* If you want it to be bold */\n  display: inline-block; /* Needed to add space between the bullet and the text */\n  width: 1em; /* Also needed for space (tweak if needed) */\n  margin-left: -1em; /* Also needed for space (tweak if needed) */\n}\n\n#downloadCatalogLinks .catalogDownload {\n  color: #1eabe3;\n  text-decoration: none;\n  font-size: 1.25em;\n  border: none;\n  background-color: white;\n  float: right;\n  margin-top: -10px;\n  margin-bottom: -10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
